
















import { Component, Vue } from 'vue-property-decorator'
import { AppNavbarNavlinks, Navlink } from '@/components/AppNavbarNavlinks.vue'

@Component({
    components: {
        'app-navbar-navlinks': AppNavbarNavlinks,
    }})
export default class AppNavbar extends Vue {
    private navlinks: Navlink[] = [
      { target: {name: 'home'}, message: 'pageTitle.start', exact: true },
      { target: {name: 'about'}, message: 'pageTitle.about' },
    ]
}
